export default () => ({
  visible: true,
  hide() {
    this.visible = false;
  },
});
